import { render, staticRenderFns } from "./RouteTruckView.vue?vue&type=template&id=bd306ae0&scoped=true"
import script from "./RouteTruckView.vue?vue&type=script&lang=ts"
export * from "./RouteTruckView.vue?vue&type=script&lang=ts"
import style0 from "./RouteTruckView.vue?vue&type=style&index=0&id=bd306ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd306ae0",
  null
  
)

export default component.exports